export enum USER_TYPE {
  AFFILIATE = 'AFFILIATE',
  COPRODUCER = 'COPRODUCER',
  PRODUCER = 'PRODUCER',
  HYBRID = 'HYBRID',
  HYBRID_COPRODUCER_AFFILIATE = 'HYBRID_COPRODUCER_AFFILIATE',
  HYBRID_PRODUCER_AFFILIATE = 'HYBRID_PRODUCER_AFFILIATE',
  HYBRID_PRODUCER_COPRODUCER = 'HYBRID_PRODUCER_COPRODUCER'
}
export enum SIZES {
  WIDTH = 720
}

export const BLACK_NOVEMBER_MENU_ID = 'black_november'

export const AUDIENCE_MENU_ID = 'audience'
export const AUDIENCE_SIDEMENU_SOURCE = 'platform_audience_button'
